export const WHATSAPP_LINK = "https://wa.me/917738384698?text=Hello%20Parsn%20Group%2C%20I%27d%20like%20to%20enquire%20about%20your%20projects.";
export const PHONE_DISPLAY = "022 4099 9999";
export const PHONE_LINK = "tel:+912240999999";
export const EMAIL = "connect@parsnindia.com";
export const OFFICE = "78/B, Nariman Bhavan, Nariman Point, Mumbai — 400021";

const img = (id) => `https://images.unsplash.com/${id}?q=80&w=1600&auto=format&fit=crop`;

export const HERO_IMAGE = "/assets/hero-rooftop.webp";
export const TIMELINE_IMAGE = "https://images.pexels.com/photos/17770160/pexels-photo-17770160.jpeg?auto=compress&cs=tinysrgb&w=1600";

export const stats = [
  { value: "50+", label: "Years of building" },
  { value: "81", label: "Projects completed" },
  { value: "5", label: "Redevelopments ongoing" },
  { value: "2", label: "Countries — India & Saudi Arabia" },
];

export const projects = [
  {
    slug: "shiv-vaibhav",
    name: "Parsn Shiv Vaibhav",
    area: "Kurla",
    tag: "Building 38",
    location: "Nehru Nagar, Kurla East",
    config: "1 RK, 1 & 2 BHK with balcony",
    rera: "P51800032409",
    status: "Ongoing",
    developer: "Parsn Construction and Developers Private Limited",
    address: "Plot No. 38, Nehru Nagar, Kurla East, Mumbai — 400024",
    blurb: "The 18 floor residents tower with thoughtfully planned 1 RK, 1 and 2 BHK balcony homes in the heart of Nehru Nagar.",
    units: [
      { type: "1 RK", area: "260 sq ft RERA carpet" },
      { type: "1 BHK", area: "460 sq ft RERA carpet" },
      { type: "2 BHK", area: "650 sq ft RERA carpet" },
      { type: "2 BHK (large)", area: "695 sq ft RERA carpet" },
    ],
    amenities: ["Lavish entrance lobby", "Rooftop amenities", "Indoor gym", "Garden deck", "Kids play area", "Sit-out area"],
    specs: ["Vitrified tile flooring", "Granite kitchen platform", "Branded CP & sanitary fittings", "Fire-rated main door", "Concealed plumbing & electrical", "Speedy lifts", "CCTV surveillance", "Hi-tech fire fighting system"],
    connectivity: ["Kurla Station — 5 min", "LTT Station — 10 min", "BKC — 15 min", "Phoenix Market City — 15 min", "Airport — 20 min", "K.J. Somaiya — 10 min"],
    hero: "/assets/projects/shiv-vaibhav/exterior-day.webp",
    gallery: [
      { src: "/assets/projects/shiv-vaibhav/exterior-day.webp", label: "Elevation — day" },
      { src: "/assets/projects/shiv-vaibhav/exterior-evening.webp", label: "Elevation — evening" },
      { src: "/assets/projects/shiv-vaibhav/exterior-night.webp", label: "Elevation — night" },
      { src: "/assets/projects/shiv-vaibhav/entrance-lobby.webp", label: "Entrance lobby" },
      { src: "/assets/projects/shiv-vaibhav/fitness-room.webp", label: "Fitness room" },
      { src: "/assets/projects/shiv-vaibhav/terrace-gazebo.webp", label: "Garden deck — gazebo sit-out" },
      { src: "/assets/projects/shiv-vaibhav/terrace-lawn.webp", label: "Garden deck — lawn & seating" },
      { src: "/assets/projects/shiv-vaibhav/kids-play-yoga.webp", label: "Kids play area & yoga corner" },
      { src: "/assets/projects/shiv-vaibhav/balcony-view.webp", label: "Deck — city view" },
    ],
    plans: [
      { src: "/assets/projects/shiv-vaibhav/plan-1rk-103.webp", label: "Flat 103 · 1 RK — isometric view" },
      { src: "/assets/projects/shiv-vaibhav/plan-1bhk-104.webp", label: "Flat 104 · 1 BHK — isometric view" },
      { src: "/assets/projects/shiv-vaibhav/plan-2bhk-106.jpg", label: "Flat 106 · 2 BHK with deck — isometric view" },
      { src: "/assets/projects/shiv-vaibhav/plan-2bhk-107.webp", label: "Flat 107 · 2 BHK — isometric view" },
    ],
  },
  {
    slug: "sharada",
    name: "Parsn Sharada",
    area: "Kurla",
    tag: "Building 62",
    location: "Kurla, Mumbai",
    config: "1 & 2 BHK · G+16 floors",
    rera: "P51800014914",
    status: "Handover Stage",
    developer: "Parsn Construction and Developers Private Limited",
    blurb: "The G+16 tower is already standing tall in Kurla. Consists of 1 and 2 BHKs designed for a spacious and functional living.",
    units: [],
    amenities: [],
    upcoming_details: true,
    hero: "/assets/projects/sharada/facade.webp",
    gallery: [
      { src: "/assets/projects/sharada/facade.webp", label: "Actual site photo — facade" },
    ],
  },
  {
    slug: "bhagyalakshmi",
    name: "Parsn Bhagyalakshmi",
    area: "Chembur",
    tag: "Chembur",
    location: "Gaothan Road No. 3, Chembur",
    config: "2 & 2.5 BHK",
    rera: "P51800053232",
    status: "Nearing Possession",
    developer: "Parsn Lifespaces",
    address: "Gaothan Road No. 3, Near Sandhu Garden, Chembur, Mumbai — 400071",
    blurb: "Bespoke 2 and 2.5 BHK residences with an open-to-sky lounge and garden deck amidst the greens of Chembur.",
    units: [
      { type: "2 BHK", area: "638 sq ft RERA carpet" },
      { type: "2.5 BHK", area: "792 sq ft RERA carpet" },
    ],
    amenities: ["Grand entrance lobby", "Open-to-sky lounge", "Garden deck", "Air-conditioned gymnasium", "Children's play area", "Ample parking slots"],
    specs: ["Modular kitchen", "Vitrified tile flooring", "Branded CP & sanitary fittings", "Designer FRD doors", "Branded electrical fittings", "Speedy lifts", "CCTV surveillance", "Hi-tech fire fighting system"],
    connectivity: ["Chembur Station", "Diamond Garden Metro", "Chembur Monorail", "The Green Acres Academy", "Zen Multi Speciality Hospital", "K Star Mall"],
    hero: "/assets/projects/bhagyalakshmi/exterior-night.webp",
    gallery: [
      { src: "/assets/projects/bhagyalakshmi/exterior-night.webp", label: "Elevation — front, dusk" },
      { src: "/assets/projects/bhagyalakshmi/aerial-rooftop.webp", label: "Aerial view — rooftop amenities" },
      { src: "/assets/projects/bhagyalakshmi/exterior-day.webp", label: "Elevation — rear, day" },
      { src: "/assets/projects/bhagyalakshmi/entrance-lobby.webp", label: "Grand entrance lobby" },
      { src: "/assets/projects/bhagyalakshmi/rooftop-seating.webp", label: "Open-to-sky lounge" },
      { src: "/assets/projects/bhagyalakshmi/lawn-jogging.webp", label: "Garden deck" },
      { src: "/assets/projects/bhagyalakshmi/kids-play.webp", label: "Kids play area" },
      { src: "/assets/projects/bhagyalakshmi/fitness-room.webp", label: "AC gym" },
    ],
    plans: [
      { src: "/assets/projects/bhagyalakshmi/plan-2bhk.webp", label: "2 BHK — isometric view" },
      { src: "/assets/projects/bhagyalakshmi/plan-25bhk-01.webp", label: "2.5 BHK · Type 1 — isometric view" },
      { src: "/assets/projects/bhagyalakshmi/plan-25bhk-02.webp", label: "2.5 BHK · Type 2 — isometric view" },
    ],
  },
  {
    slug: "pancharatna",
    name: "Parsn Pancharatna",
    area: "Kurla",
    tag: "Plot 5",
    location: "Nehru Nagar, Kurla East",
    config: "1 RK, 1 & 2 BHK · G+16 floors",
    rera: "P51800015096",
    status: "Handover Stage",
    developer: "Parsn Construction and Developers Private Limited",
    address: "Plot 5, Nehru Nagar, Kurla East, Mumbai — 400024",
    blurb: "A G+16 tower in the heart of Nehru Nagar, Kurla with efficient 1 RK, 1 and 2 BHK homes.",
    units: [
      { type: "1 RK", area: "262 sq ft RERA carpet" },
      { type: "1 BHK", area: "399 sq ft RERA carpet" },
      { type: "2 BHK", area: "615 sq ft RERA carpet" },
    ],
    amenities: ["Decorative lobby", "Vitrified tile flooring", "Standard plumbing fittings"],
    connectivity: ["Next to SCLR", "Kurla Station — 5 min", "LTT — 10 min", "BKC — 15 min", "K.J. Somaiya — 15 min", "Airport — 20 min"],
    hero: "/assets/projects/pancharatna/elevation.webp",
    gallery: [
      { src: "/assets/projects/pancharatna/elevation.webp", label: "Elevation — G+16 tower" },
    ],
    plans: [
      { src: "/assets/projects/pancharatna/plan-1rk.png", label: "1 RK · 262 sq ft — isometric view" },
      { src: "/assets/projects/pancharatna/plan-1bhk.png", label: "1 BHK · 399 sq ft — isometric view" },
      { src: "/assets/projects/pancharatna/plan-2bhk.png", label: "2 BHK · 615 sq ft — isometric view" },
      { src: "/assets/projects/pancharatna/plan-typical-floor.png", label: "Typical floor plan" },
    ],
  },
  {
    slug: "avighna",
    name: "Parsn Avighna",
    area: "Chembur",
    tag: "Chembur",
    location: "Chembur, Mumbai",
    config: "Launching soon",
    rera: "P51800016404",
    status: "Ongoing",
    developer: "Parsn Construction and Developers Private Limited",
    blurb: "Our next chapter in Chembur is at the center of accessible commute. Planning and renders are underway and will be brought to you very soon.",
    cta: "Register your interest",
    units: [],
    amenities: [],
    upcoming_details: true,
    hero: img("photo-1503387762-592deb58ef4e"),
    gallery: [
      img("photo-1504307651254-35680f356dfd"),
      img("photo-1541888946425-d81bb19240f5"),
      img("photo-1487958449943-2429e8be8625"),
    ],
  },
];

export const timeline = [
  { era: "1971 – 72", title: "St. Xavier College, Annex Building", text: "The first chapter — an annex for one of Bombay's most storied institutions.", img: "/assets/landmarks/st-xavier-1971.png" },
  { era: "1972 – 73", title: "Saudi Projects and Bombay Port Trust", text: "Executed piling works in Saudi, 40% of Bombay Port Trust piling and the Chennai Sachivalay.", img: "/assets/landmarks/bpt-cranes-1972.png" },
  { era: "1973 – 74", title: "K.E.M. Hospital, Pune", text: "Piling works for the multistoried Diamond Jubilee Building — later appreciated by the late Prime Minister.", img: "/assets/landmarks/kem-hospital-1973.jpg" },
  { era: "1974 – 75", title: "Borivali School", text: "A Ground + 4 floor school with auditorium.", img: "/assets/landmarks/borivali-school-1974.png" },
  { era: "1975 – 76", title: "Nariman Point", text: "Piling works of 40% of a multistoried building at Nariman Point, executed successfully.", img: "/assets/landmarks/nariman-point-1975.webp" },
  { era: "1976 – 80", title: "Gemini Studios & Chennai", text: "Ten buildings of more than Ground + 9 floors each at Gemini Studio and other projects in Chennai.", img: "/assets/landmarks/gemini-studios-1976.jpg" },
  { era: "1979 – 81", title: "Versova, for Mumbai's teachers", text: "Residential buildings at Versova for the Mumbai Teachers Associations.", img: "/assets/landmarks/versova-1979.png" },
  { era: "1982", title: "Vinalaya Campus Work, Andheri", text: "Development of property at Vinalaya Road including the St. Xavier's and St. Annie's campus development at Mahakali Caves, Andheri.", img: "/assets/landmarks/vinalaya-1982.webp" },
  { era: "1985", title: "Holy Cross Society, Kalyan", text: "Development of Holy Cross Society land at Kalyan — hospitals, a school and a 25-foot auditorium.", img: "/assets/landmarks/holy-cross-1985.webp" },
  { era: "1987", title: "Kalyan & Vasai", text: "Residential buildings across Kalyan and Vasai.", img: "/assets/landmarks/kalyan-vasai-1987.webp" },
  { era: "1989", title: "St. Annie, Mira Bhayander", text: "School and hospital for St. Annie in Mira Bhayander.", img: "/assets/landmarks/st-annes-1989.jpg" },
  { era: "1990 – 2000", title: "High Court Judges Residency, BKC", text: "High Court Judges Buildings, major MBMC office buildings and clubhouses; St. Joseph Church for priests, Our Lady of Nazareth Church and Holy Cross School.", img: "/assets/landmarks/high-court-judges-1990.webp" },
  { era: "2005 – 20", title: "The redevelopment decade", text: "10+ redevelopment projects across Kurla and Chembur — older societies returned to their residents as modern homes.", img: "/assets/projects/shiv-vaibhav/exterior-day.webp" },
  { era: "Present Day", title: "Ongoing Projects", text: "Five active redevelopment projects across Chembur and Kurla — delivering renewed homes and dreams to home buyers.", img: "/assets/projects/bhagyalakshmi/exterior-night.webp" },
];

export const recognition = [
  { source: "Late Prime Minister Smt. Indira Gandhi", detail: "Token of appreciation for the construction of the Diamond Jubilee Building, K.E.M. Hospital, Pune.", img: "/assets/awards/indira-gandhi-kem.png" },
  { source: "Maharashtra Holy Cross Sisters' Society", detail: "Gratitude & appreciation for construction work carried out at Kalyan, Bhayander & Mira Road.", img: "/assets/awards/holy-cross-society.png" },
  { source: "St. Joseph Church", detail: "Gratitude & appreciation for the construction of the church, Mira Road.", img: "/assets/awards/st-joseph-church.png" },
  { source: "Church of Our Lady of Holy Nazareth", detail: "Gratitude and appreciation for the construction of the church, Bhayander.", img: "/assets/awards/our-lady-nazareth.png" },
];

export const completedProjects = [
  { name: "Jai Rameshwar CHS", area: "50,000", year: "1972" },
  { name: "Gokul Corporation", area: "25,000", year: "1974" },
  { name: "Building No. 26, Yashodeep CHS", area: "28,000", year: "2004" },
  { name: "Building No. 24, Mamata CHS", area: "28,000", year: "2005" },
  { name: "Building No. 13, Ashirwad CHS", area: "28,000", year: "2006" },
  { name: "Building No. 17, Swadham CHS", area: "23,500", year: "2007" },
  { name: "Building No. 48, Sampada CHS", area: "28,000", year: "2008" },
  { name: "Building No. 41, Sai Sadan CHS", area: "47,000", year: "2009" },
  { name: "Nyaya Sagar CHS", area: "40,000", year: "2010" },
  { name: "Siddhagiri Condominium", area: "40,000", year: "2010" },
  { name: "Building No. 68, Kurla Sahayog CHS", area: "50,000", year: "2018" },
];

export const leadership = [
  { name: "Rajan Pathare", role: "Director" },
  { name: "Krupa Pathare", role: "Director & CFO" },
  { name: "Divij Pathare", role: "Operations Lead" },
];
